import { render, staticRenderFns } from "./ExpeVegetarian.vue?vue&type=template&id=3dc85a92&scoped=true&"
import script from "./ExpeVegetarian.vue?vue&type=script&lang=js&"
export * from "./ExpeVegetarian.vue?vue&type=script&lang=js&"
import style0 from "./ExpeVegetarian.vue?vue&type=style&index=0&id=3dc85a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc85a92",
  null
  
)

export default component.exports